module.exports = __webpack_public_path__ + "media/financial.cb6f5563.mp4";